import React, { Fragment, useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab } from "@material-ui/core";
import HistoryDetailsItems from "./HistoryDetailsItems";
import HistoryDetailsPayments from "./HistoryDetailsPayments";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function HistoriesDetails(props) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState('history-details-items');

  const handleChange = (event, value) => {
    setTab(value);
  }

  useEffect(() => {
    const historyId = props.location.pathname.split(
      "/dashboard/payment/histories/"
    )[1];
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: historyId,
        };
        const response = await PaymentService.GetHistoryDetails(params);
        const err = StatusHandler(response);
        if (!err.isFail) {
          setData(response.data.Value);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, [props.location.pathname]);

  return (
    <Fragment>
      <TabContext value={tab}>
        <Box>
          <TabList onChange={handleChange} variant="scrollable">
            <Tab
              label={t("history_details")}
              value="history-details-items"
            />
            <Tab
              label={t("history_payments")}
              value="history-details-payments"
            />
          </TabList>
        </Box>
        <MuiPaper>
          <TabPanel value="history-details-items">
            <HistoryDetailsItems loading={loading} data={data?.Items}/>
          </TabPanel>
          <TabPanel value="history-details-payments">
            <HistoryDetailsPayments loading={loading} data={data?.Payments}/>
          </TabPanel>
        </MuiPaper>
      </TabContext>
    </Fragment>
  );
}

export default HistoriesDetails;
